handle.$inject = [ '$transitions', 'MiddlewareService' ];

/**
 * @param {$transitions} $transitions
 * @param {MiddlewareService} MiddlewareService
 */
export default function handle($transitions, MiddlewareService) {

    $transitions.onStart({}, (transition) => {

        return MiddlewareService.handle(transition);
    });

    $transitions.onError({}, (transition) => {

    });
}



// WEBPACK FOOTER //
// ./src/middleware/middleware.handle.js